//追缴规则
const RuleConfiguration = () => import(/*webpackChunkName:'sale'*/"@/page/sale/arrearsRecovery/ruleConfiguration.vue")
const ArrearsListTab =()=>import(/*webpackChunkName:'sale'*/"@/page/sale/arrearsRecovery/ArrearsList/ArrearsListTab.vue")
const ArrearsStatistics=()=>import(/*webpackChunkName:'sale'*/"@/page/sale/arrearsRecovery/ArrearsStatistics/ArrearsStatistics.vue")
const RouteTemp = () => import(/*webpackChunkName:'sale'*/'@/page/commons/routeTemp.vue')

export  const arrearsRecovery=
    {
        path: '/main/arrears-recovery',
        name: '欠费追缴',
        meta: {
            requireAuth: true,
        },
        component: RouteTemp,
        children: [{
            path: '/main/recovery-rules/rule-configuration',
            name: '规则设置',
            meta: {
                requireAuth: true,
            },
            component: RuleConfiguration
        },
        {
            path: '/main/recovery-rules/arrears-list',
            name: '欠费列表',
            meta: {
                requireAuth: true,
            },
            component: ArrearsListTab
        },
        {
            path: '/main/recovery-rules/arrears-statistics',
            name: '欠费统计',
            meta: {
                requireAuth: true,
            },
            component:ArrearsStatistics
        },
       ]
    }